var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Back Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.1 17.85L3.25 12L9.1 6.15002L10.4 7.48752L6.825 11.0625H20.75V12.9375H6.825L10.4 16.5125L9.1 17.85Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackArrow);
export default __webpack_public_path__ + "static/media/icon-back-arrow.8d77caca13c23cb5c08d6f6e63b986e8.svg";
export { ForwardRef as ReactComponent };